import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalHeader from '../common/modal/header';
import ModalFooter from '../common/modal/footer';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;

class VoucherWarning extends React.Component {
    static propTypes = {
        voucher_error_message: PropTypes.string,
        voucher_applied: PropTypes.shape({
            name: PropTypes.string,
        }),
        closeModal: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    onProceedButtonClick = () => {
        this.props.closeModal(true);
        UI.trigger('progressForward', 'preconfirmation_warning');

        Order.log(
            'preconfirmation warning voucher missing requirement ignored',
            {
                voucher_error_message: this.props.voucher_error_message,
                voucher_applied: this.props.voucher_applied,
            }
        );
    };

    onCancelButtonClick = () => {
        this.props.closeModal();
        Order.log(
            'preconfirmation warning voucher missing requirement abided',
            {
                voucher_error_message: this.props.voucher_error_message,
                voucher_applied: this.props.voucher_applied,
            }
        );
    };

    getMessage = () => {
        if (this.props.voucher_error_message) {
            return this.props.voucher_error_message;
        }

        return this.props.t('voucher_error_message', {
            reward_label: this.props.t('customer.rewards:label'),
        });
    };

    render() {
        const { t } = this.props;
        return (
            <div className="m2g-preconfirmation-warning">
                <ModalHeader
                    headerText={t('missing_reward', {
                        reward_label: t('customer.rewards:label'),
                    })}
                    onClose={this.onCancelButtonClick}
                />
                <div className="m2g-modal-body m2g-preconfirmation-warning-voucher">
                    <div className="m2g-preconfirmation-warning-voucher-name">
                        <div className="m2g-preconfirmation-warning-voucher-name-icon m2g-icon m2g-icon--medium m2g-icon--gift" />
                        <div className="m2g-preconfirmation-warning-voucher-name-text">
                            {this.props.voucher_applied.name}
                        </div>
                    </div>
                    <div className="m2g-preconfirmation-warning-voucher-error-message m2g-alert">
                        <div className="m2g-preconfirmation-warning-voucher-error-message-icon m2g-icon m2g-icon--alert" />
                        <div className="m2g-preconfirmation-warning-voucher-error-message-text">
                            {this.getMessage()}
                        </div>
                    </div>
                    <div className="m2g-preconfirmation-warning-voucher-message">
                        {t('voucher_warning')}
                    </div>
                </div>
                <ModalFooter>
                    <ModalFooter.Right>
                        <button
                            onClick={this.onCancelButtonClick}
                            className="m2g-button m2g-button--fat"
                        >
                            {t('edit_order')}
                        </button>
                        <button
                            onClick={this.onProceedButtonClick}
                            className="m2g-button m2g-button--fat m2g-button--primary"
                        >
                            {t('continue_anyway')}
                        </button>
                    </ModalFooter.Right>
                </ModalFooter>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.preconfirmation-warning')(
    VoucherWarning
);
